import React, { useContext, useState } from "react";
import { message } from "antd";
import { errorMessage, QuestionType } from "../../../../../service/service";
import {
    checkTopic,
    getEmptyTopicChoice,
    removeTopics,
    TopicType
} from "../../../../../service/homework";
import _ from "underscore";
import usePromiseCallback from "utils/usePromiseCallback";
import { EditCompoundPure } from "../../../../exam/addExam/components/EditCompound";
import { EditBlock } from "../EditBlock";
import HomeworkContext from "../../context";

interface EditCompoundProps {
    topic: TopicType;
    onChange: (topic: TopicType) => void;
}

export default function EditCompound({ topic, onChange }: EditCompoundProps) {
    const { paperId, setTopics, topics } = useContext(HomeworkContext);
    const [innerTopic, setInnerTopic] = useState(topic);

    const onTopicChange = (topic: TopicType) => {
        const newTopic = { ...innerTopic };
        newTopic.topics = newTopic.topics.map(item => {
            return item.tempTopicId === topic.tempTopicId ? topic : item;
        });
        const score = _.reduce(
            newTopic.topics,
            (memo, num) => {
                //@ts-ignore
                return memo + parseFloat(num.score);
            },
            0
        );
        newTopic.score = score;

        setInnerTopic(newTopic);
    };

    const addTopic = (type: QuestionType) => {
        const newTopic = { ...innerTopic };
        const topic = getEmptyTopicChoice(type);
        newTopic.topics.push(topic);
        setInnerTopic(newTopic);
    };

    const onDelete = usePromiseCallback((topic: TopicType) => {
        return removeTopics([topic], paperId)
            .then(() => {
                const newTopic = {
                    ...innerTopic,
                    score: _.reduce(
                        innerTopic.topics.filter(
                            item => item.tempTopicId !== topic.tempTopicId
                        ),
                        (memo, num) => {
                            //@ts-ignore
                            return memo + parseFloat(num.score);
                        },
                        0
                    )
                };
                const index = newTopic.topics.findIndex(
                    item => item.tempTopicId === topic.tempTopicId
                );
                if (index >= 0) {
                    newTopic.topics.splice(index, 1);
                }
                setInnerTopic(newTopic);
            })
            .then(() => !!message.info("删除成功!"))
            .catch(e => message.error(errorMessage(e)));
    });

    const onCheck = (
        topic: TopicType
    ): { result: "success" | "error"; msg?: string } => {
        const checkOption = { trunk: false };
        if (topic.topicType === QuestionType.WanXingTianKong) {
            checkOption.trunk = true;
        }

        if (!topic.trunk) {
            return { result: "error", msg: "请填写题目内容!" };
        }

        if (topic.topics.length === 0) {
            return { result: "error", msg: "请添加题型！" };
        }

        for (const item of topic.topics) {
            const { result, msg } = checkTopic(item, checkOption);
            if (result === "error") {
                return { result, msg };
            }
        }

        return { result: "success" };
    };

    return (
        <EditBlock
            customCheckTopic={onCheck}
            autoScore={innerTopic.score}
            disableScore
            type={innerTopic.topicType}
            topic={innerTopic}
            onChange={onChange}>
            <EditCompoundPure
                innerTopic={innerTopic}
                onTopicChange={onTopicChange}
                onDelete={onDelete}
                addTopic={addTopic}
            />
        </EditBlock>
    );
}
